__turbopack_context__.v({
  "longTitle": "object-title-module-scss-module__po8Feq__longTitle",
  "regularTitle": "object-title-module-scss-module__po8Feq__regularTitle",
  "title": "object-title-module-scss-module__po8Feq__title",
  "veryLongTitle": "object-title-module-scss-module__po8Feq__veryLongTitle",
});
